import SelectReact, { Props as SelectProps } from "react-select";
import Creatable from "react-select/creatable";
import styled, { css } from "styled-components";
import { FIELD_HEIGHT } from "styles/sizes";

type SelectStylesProps = {
  $invalid: boolean;
  $minHeight: number;
};

export const selectStyles = css<SelectStylesProps>`
  text-align: left;

  .react-select__control--is-disabled {
    background-color: ${({ theme }) => theme.subtleHover};
    border-color: ${({ theme }) => theme.formBorder};
  }

  .react-select__control {
    border-color: ${({ theme, $invalid }) =>
      $invalid ? theme.red : theme.formBorder};
    border-radius: 2px;
    box-shadow: none;
    padding-left: 8px;
    min-height: ${({ $minHeight }) => `${$minHeight || FIELD_HEIGHT}px`};
    font-size: 0.9375rem;
    transition: all 0.2s ease;
    background-color: ${({ theme }) => theme.inputBg};
    color: ${({ theme }) => theme.textMain};
  }

  .react-select__single-value {
    color: ${({ theme }) => theme.textMain};
  }

  .react-select__input-container {
    color: ${({ theme }) => theme.textMain};
  }

  .react-select__value-container {
    padding: 3px 0;
    display: flex;
  }

  .react-select__control--is-focused {
    border-color: ${({ theme, $invalid }) =>
      $invalid ? theme.red : theme.fieldFocusBorder};
    box-shadow: ${({ theme, $invalid }) =>
      $invalid ? `0 0 0 4px ${theme.errorFocusRing}` : theme.fieldFocusShadow};
  }

  .react-select__indicator-separator {
    display: none;
  }

  /* Centred by the control's flex row, whatever its height. */
  .react-select__indicator {
    display: flex;
    transition: transform 0.3s ease-in-out;
  }

  .react-select__control--is-focused .react-select__indicator {
    transform: rotate(-180deg);
  }

  .react-select__control .react-select__indicator i {
    background-color: ${({ theme, $invalid }) => $invalid && theme.red};
  }

  .react-select__control--is-focused .react-select__indicator i {
    background-color: ${({ theme, $invalid }) =>
      $invalid ? theme.red : theme.primary};
  }

  .react-select__menu {
    border-radius: 2px;
    margin-top: 6px;
    font-size: 0.9375rem;
    overflow: hidden;
    background-color: ${({ theme }) => theme.surfaceElevated};
    border: 1px solid ${({ theme }) => theme.formBorder};
  }

  .react-select__option {
    color: ${({ theme }) => theme.textMain};
    background-color: transparent;

    &:hover,
    &--is-focused {
      background-color: ${({ theme }) => theme.subtleHover};
    }

    &--is-selected {
      background-color: ${({ theme }) => theme.checkedRowBg};
      color: ${({ theme }) => theme.primary};
    }
  }

  .react-select__placeholder {
    color: ${({ theme }) => theme.textPlaceholder};
  }

  .react-select__menu-list {
    max-height: 100%;
  }

  .react-select__clear-indicator {
    padding: 5px;
  }

  .react-select__clear-indicator > svg {
    height: 24px;
    width: 24px;
    fill: ${({ theme }) => theme.red};
  }
`;

type OptionType = {
  value: string;
  label: string;
  image: string;
};

export const PlainSelect = styled(SelectReact)<
  SelectProps<OptionType, false> & SelectStylesProps
>`
  ${selectStyles}
`;
export const CreatableSelect = styled(Creatable)<
  SelectProps<OptionType, false> & SelectStylesProps
>`
  ${selectStyles}
`;
